import { create } from 'zustand';
import { CurrentUserType } from '../types';

export const isAdmin: { [key: number]: boolean } = {
	1: true, //is admin
	2: false, // user
	0: false,
} as const;

interface IState {
	user: CurrentUserType | null;
	isAdmin: boolean | null;
	setUser: (user: CurrentUserType | null) => void;
}

export const useDefaultUserStore = create<IState>(set => ({
	user: null,
	isAdmin: null,
	setUser: user =>
		set(() => ({
			user,
			isAdmin: user ? isAdmin[user.roleId] : null,
		})),
}));
